import { Component, OnInit, Input } from '@angular/core';
import { BulkHttpService } from '../../../../core/bulk';
import { MatStepper, MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { SelectOption } from '../../../partials/content/general/searchable-select/searchable-select.component';

@Component({
  selector: 'kt-machine-category',
  templateUrl: './machine-category.component.html',
  styleUrls: ['./machine-category.component.scss']
})
export class MachineCategoryComponent implements OnInit {

	@Input() mList: any[];

	@Input() stepperObj: MatStepper;

	machineType: string | number | null = null;

	selStatus: string | number | null = null;

	stageStatuses = [];

	machineTypeOptions: SelectOption[] = [
		{ value: '', label: 'N/A' },
		{ value: 0, label: 'Production' },
		{ value: 1, label: 'Test' }
	];
	statusOptions: SelectOption[] = [{ value: '', label: 'N/A' }];

	constructor(private http: BulkHttpService, private router: Router, private _snackBar: MatSnackBar) { }

	ngOnInit() {
		this.getStageStatus();
	}

	getStageStatus() {
		this.http.getStageStatus()
		.subscribe(stageStatuses => {
			this.stageStatuses = stageStatuses;
			this.statusOptions = [
				{ value: '', label: 'N/A' },
				...stageStatuses.map((stage: any) => ({
					value: stage.status,
					label: stage.label
				}))
			];
		});
	}

	back() {
		this.stepperObj.previous();
	}

	submit() {
		const machineTypeValue = this.machineType || '';
		const statusValue = this.selStatus || '';

		console.log(machineTypeValue, statusValue);
		let machines = [];
		if (this.mList.length) {
			for (let m of this.mList) {
				machines.push(m.m_id);
			}
		} else {
			return;
		}

		let obj = {
			test_machine: machineTypeValue,
			status: statusValue,
			machines: `'${machines.join("','")}'`
		};
		this.http.updateMacCategory(obj)
		.subscribe(result => {
			this.showSnackBar('Updated successfully!', 0);
			this.router.navigate(['group-actions'], {queryParams: {reset: true}});
			this.stepperObj.reset();
		}, error => {
			this.showSnackBar('Update failed!', 0);
			console.log(error);
		});
	}

	showSnackBar(message: string, duration: number) {
		let snackRef = this._snackBar.open(message, 'close');
		if (duration > 0) {
			setTimeout(() => {
				this._snackBar.dismiss();
			}, duration);
		}

		snackRef.onAction().subscribe(() => {
			this._snackBar.dismiss();
		});
	}

}
